import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'assignee'
	| 'reporter'
	| 'priority'
	| 'status'
	| 'type'
	| 'issuetype'
	| 'project'
	| 'labels'
	| 'created'
	| 'updated'
	| 'duedate'
	| 'sprint'
	| 'parent'
	| 'resolution'
	| 'fixversion'
	| 'affectedversion'
	| 'approvals'
	| 'attachments'
	| 'category'
	| 'comment'
	| 'creator'
	| 'description'
	| 'due'
	| 'environment'
	| 'filter'
	| 'issuekey'
	| 'issuelink'
	| 'issuelinktype'
	| 'epiclink'
	| 'lastviewed'
	| 'level'
	| 'originalestimate'
	| 'remainingestimate'
	| 'statuscategory'
	| 'summary'
	| 'text'
	| 'timespent'
	| 'voter'
	| 'votes'
	| 'watcher'
	| 'watchers'
	| 'worklogcomment'
	| 'worklogdate'
	| 'workratio';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		assignee: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.assignee',
			defaultMessage: 'Assignee',
			description: 'Label for the JQL "assignee" field shown above its filter chips.',
		},
		reporter: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.reporter',
			defaultMessage: 'Reporter',
			description: 'Label for the JQL "reporter" field shown above its filter chips.',
		},
		priority: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.priority',
			defaultMessage: 'Priority',
			description: 'Label for the JQL "priority" field shown above its filter chips.',
		},
		status: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.status',
			defaultMessage: 'Status',
			description: 'Label for the JQL "status" field shown above its filter chips.',
		},
		type: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.type',
			defaultMessage: 'Work type',
			description: 'Label for the JQL "type" field shown above its filter chips.',
		},
		issuetype: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.issuetype',
			defaultMessage: 'Work type',
			description: 'Label for the JQL "issuetype" field shown above its filter chips.',
		},
		project: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.project',
			defaultMessage: 'Project',
			description: 'Label for the JQL "project" field shown above its filter chips.',
		},
		labels: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.labels',
			defaultMessage: 'Labels',
			description: 'Label for the JQL "labels" field shown above its filter chips.',
		},
		created: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.created',
			defaultMessage: 'Created',
			description: 'Label for the JQL "created" field shown above its filter chips.',
		},
		updated: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.updated',
			defaultMessage: 'Updated',
			description: 'Label for the JQL "updated" field shown above its filter chips.',
		},
		duedate: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.duedate',
			defaultMessage: 'Due date',
			description: 'Label for the JQL "duedate" field shown above its filter chips.',
		},
		sprint: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.sprint',
			defaultMessage: 'Sprint',
			description: 'Label for the JQL "sprint" field shown above its filter chips.',
		},
		parent: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.parent',
			defaultMessage: 'Parent',
			description: 'Label for the JQL "parent" field shown above its filter chips.',
		},
		resolution: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.resolution',
			defaultMessage: 'Resolution',
			description: 'Label for the JQL "resolution" field shown above its filter chips.',
		},
		fixversion: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.fixversion',
			defaultMessage: 'Fix version',
			description: 'Label for the JQL "fixversion" field shown above its filter chips.',
		},
		affectedversion: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.affectedversion',
			defaultMessage: 'Affected version',
			description: 'Label for the JQL "affectedversion" field shown above its filter chips.',
		},
		approvals: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.approvals',
			defaultMessage: 'Approvals',
			description: 'Label for the JQL "approvals" field shown above its filter chips.',
		},
		attachments: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.attachments',
			defaultMessage: 'Attachments',
			description: 'Label for the JQL "attachments" field shown above its filter chips.',
		},
		category: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.category',
			defaultMessage: 'Category',
			description: 'Label for the JQL "category" field shown above its filter chips.',
		},
		comment: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.comment',
			defaultMessage: 'Comment',
			description: 'Label for the JQL "comment" field shown above its filter chips.',
		},
		creator: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.creator',
			defaultMessage: 'Creator',
			description: 'Label for the JQL "creator" field shown above its filter chips.',
		},
		description: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.description',
			defaultMessage: 'Description',
			description: 'Label for the JQL "description" field shown above its filter chips.',
		},
		due: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.due',
			defaultMessage: 'Due date',
			description: 'Label for the JQL "due" field shown above its filter chips.',
		},
		environment: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.environment',
			defaultMessage: 'Environment',
			description: 'Label for the JQL "environment" field shown above its filter chips.',
		},
		filter: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.filter',
			defaultMessage: 'Filter',
			description: 'Label for the JQL "filter" field shown above its filter chips.',
		},
		issuekey: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.issuekey',
			defaultMessage: 'Key',
			description: 'Label for the JQL "issuekey" field shown above its filter chips.',
		},
		issuelink: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.issuelink',
			defaultMessage: 'Linked issues',
			description: 'Label for the JQL "issuelink" field shown above its filter chips.',
		},
		issuelinktype: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.issuelinktype',
			defaultMessage: 'Link type',
			description: 'Label for the JQL "issuelinktype" field shown above its filter chips.',
		},
		epiclink: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.epiclink',
			defaultMessage: 'Epic Link',
			description: 'Label for the JQL "epiclink" field shown above its filter chips.',
		},
		lastviewed: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.lastviewed',
			defaultMessage: 'Last viewed',
			description: 'Label for the JQL "lastviewed" field shown above its filter chips.',
		},
		level: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.level',
			defaultMessage: 'Security level',
			description: 'Label for the JQL "level" field shown above its filter chips.',
		},
		originalestimate: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.originalestimate',
			defaultMessage: 'Original estimate',
			description: 'Label for the JQL "originalestimate" field shown above its filter chips.',
		},
		remainingestimate: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.remainingestimate',
			defaultMessage: 'Remaining estimate',
			description: 'Label for the JQL "remainingestimate" field shown above its filter chips.',
		},
		statuscategory: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.statuscategory',
			defaultMessage: 'Status category',
			description: 'Label for the JQL "statuscategory" field shown above its filter chips.',
		},
		summary: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.summary',
			defaultMessage: 'Summary',
			description: 'Label for the JQL "summary" field shown above its filter chips.',
		},
		text: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.text',
			defaultMessage: 'Text',
			description: 'Label for the JQL "text" field shown above its filter chips.',
		},
		timespent: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.timespent',
			defaultMessage: 'Time spent',
			description: 'Label for the JQL "timespent" field shown above its filter chips.',
		},
		voter: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.voter',
			defaultMessage: 'Voter',
			description: 'Label for the JQL "voter" field shown above its filter chips.',
		},
		votes: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.votes',
			defaultMessage: 'Votes',
			description: 'Label for the JQL "votes" field shown above its filter chips.',
		},
		watcher: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.watcher',
			defaultMessage: 'Watcher',
			description: 'Label for the JQL "watcher" field shown above its filter chips.',
		},
		watchers: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.watchers',
			defaultMessage: 'Watchers',
			description: 'Label for the JQL "watchers" field shown above its filter chips.',
		},
		worklogcomment: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.worklogcomment',
			defaultMessage: 'Log work comment',
			description: 'Label for the JQL "worklogcomment" field shown above its filter chips.',
		},
		worklogdate: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.worklogdate',
			defaultMessage: 'Log work date',
			description: 'Label for the JQL "worklogdate" field shown above its filter chips.',
		},
		workratio: {
			id: 'conversation-assistant-message-actions.jira-view-create-and-configure.field-label.workratio',
			defaultMessage: 'Work ratio',
			description: 'Label for the JQL "workratio" field shown above its filter chips.',
		},
	});

export default messages;
